import { AllotmentService } from './../../../management/services/allotment.service';
import { IServiceBook } from './../../../_models/profile-sections/IServiceBook';
import { ProfileService } from './../../../shared/services/profile.service';
import { IProfile } from './../../../_models/account/IProfile';
import { ITransferRequest } from './../../../_models/transfer-sections/ITransferRequest';
import { SettingService } from './../../../shared/services/setting.service';
import { ISetting } from './../../../_models/cms/ISetting';
import { CommonService } from './../../../shared/services/common.service';
import { TransferRequestService } from './../../../shared/services/transfer-request.service';
import { ToastrService } from 'ngx-toastr';
import { IKeyValuePair } from './../../../_models/common/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-transfer-request-form',
  templateUrl: './transfer-request-form.component.html'
})
export class TransferRequestComponent implements OnInit {

  loading: boolean;
  skeleton: boolean = true;
  title: string = 'Add Transfer Request';
  transferRequest: ITransferRequest;
  transferRequestForm: FormGroup;
  id;
  isTransfer: boolean = false;
  isHardStation: boolean = false;
  profileId: string = '';
  transferCategories: IKeyValuePair[];

  setting: ISetting;
  presentPlace: IServiceBook;

  constructor(private router: Router,  
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private profileService: ProfileService,
    private service: TransferRequestService,
    private settingService: SettingService,
    private allotmentService: AllotmentService,) {
  }

  async ngOnInit() {
    this.createTransferRequestForm();

    this.setting = await this.settingService.getSetting();
    if (!this.setting.isTransfer) {
      this.toastrService.warning("transfer request module closed!");
      this.router.navigate(['/employee']);
      return;
    }

    if (this.setting.phaseId > 1 && !await this.isSecondRoundAllowed()) {
      this.toastrService.warning("You are not eligible to apply in Round-II.");
      this.router.navigate(['/employee']);
      return;
    }

    if (this.setting) {
      this.transferRequestForm.patchValue({
        financialYearId: this.setting.financialYearId,
        phaseId: this.setting.phaseId
      });
    }

    this.getProfile();
  }

  private isSecondRoundAllowed(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.allotmentService.getLogged().subscribe((response: any) => {
        console.log('1', response);
        //if (response && !((response.transferCategoryId != 7 && (response.schoolId || response.schoolId == null)) || (response.transferCategoryId != 7 && (response.isTransfer == true || response.isTransfer == false))))
        //if (response && (response.schoolId == null || (response.transferCategoryId == 7 && (response.schoolId || response.schoolId == null)) || (response.transferCategoryId == 7 && (response.isTransfer == true)) && (response.TransferCategoryId != 7 && response.IsTransfer == true))) {
        if (response && (response.schoolId == null && (response.TransferCategoryId != 7 && (response.IsTransfer != false || response.IsTransfer == true)) || (response.transferCategoryId == 7 && (response.schoolId || response.schoolId == null)) || (response.transferCategoryId == 7 && (response.isTransfer == true || response.isTransfer == false)))) {
          console.log('2', response);
          resolve(true);
        }
        else {
          console.log('3', response);
          resolve(false);
        }
      });
    });
  }

  getProfile() {
    this.profileService.logged().subscribe((response: IProfile) => {
      if (response) {
        if (this.isValidServiceBook(response?.serviceBooks)) {
          this.getTransferRequest();
          this.presentPlace = response?.serviceBooks.find(x => x.isPresent);
        }
        else {
          this.toastrService.warning('You must enter present place details.');
          this.router.navigate(['/employee/service-book/present-place']);
        }
      }
      else {
        this.toastrService.success('you must fill up profile first.');
        this.router.navigate(['/employee/profile']);
      }
    });
  }

  isPresentPlain() {
    return this.presentPlace.school.schoolTypeId == 1;
  }

  isValidServiceBook(serviceBooks: IServiceBook[]): boolean {
    if (serviceBooks) {
      return serviceBooks.filter(x => x.isPresent == true).length == 1;
    }
    else {
      return false;
    }
  }

  getTransferRequest() {
    this.service.logged().subscribe((response: ITransferRequest) => {
      if (response) {
        if (response.isConfirm) {
          this.toastrService.warning("You have already confirm application. You are not able to edit.");
          this.router.navigate(['/employee']);
        }
        this.transferRequest = response;
        this.id = this.transferRequest.id;
        this.title = 'Edit Transfer Request';
        this.id = response.id;
        this.setValueTransferRequestFForm();
      }
      // else {
      //   this.toastrService.warning("You are not Updated the profile for ATD-2023.");
      //   this.router.navigate(['/employee']);
      // }
    },
      (error) => console.log('HTTP Error', error),
      () => this.skeleton = false);
  }

  createTransferRequestForm() {
    this.transferRequestForm = this.fb.group({
      id: ['0'],
      financialYearId: [this.setting?.financialYearId, Validators.required],
      phaseId: [this.setting?.phaseId, Validators.required],
      profileId: [''],
      isTransfer: [false, Validators.required],
      isHardStation: [false]
    });
  }

  setValueTransferRequestFForm() {
    this.transferRequestForm.patchValue({
      id: this.transferRequest.id,
      financialYearId: this.transferRequest.financialYearId,
      phaseId: this.transferRequest.phaseId,
      profileId: this.transferRequest.profileId,
      isTransfer: this.transferRequest.isTransfer,
      isHardStation: this.transferRequest.isHardStation
    });
  }

  // save() {
  //   if (this.transferRequestForm.valid) {
  //     this.loading = true;
  //     this.transferRequest = Object.assign({}, this.transferRequestForm.value);
  //     this.isHardStation = this.transferRequest.isHardStation;
  //     this.isTransfer = this.transferRequest.isTransfer;
  //     this.profileId = this.transferRequest.profileId;
  //     if (this.id) {
  //       if (this.transferRequest.isTransfer) {
  //         this.router.navigate(['/employee/transfer-request/preference'], {
  //           queryParams: {
  //             id: this.id,
  //             isHardStation: this.isHardStation,
  //             isTransfer: this.isTransfer,
  //             profileId: this.profileId
  //           }
  //         });
  //       }
  //       else {
  //         this.service.update(this.id, this.transferRequest).subscribe((response: ITransferRequest) => {
  //           if (response && response.isTransfer) {
  //             this.transferRequest = response;
  //             this.toastrService.success('transfer request updated successful');
  //             this.router.navigate(['/employee/transfer-request/preference']);
  //           }
  //           else if (response && !response.isTransfer) {
  //             this.transferRequest = response;
  //             this.toastrService.success('transfer request updated successful');
  //             this.router.navigate(['/employee/transfer-request/view']);
  //           }
  //         },
  //           (error) => console.log('HTTP Error', error),
  //           () => this.loading = false);
  //       }
  //     }
  //     else {
  //       this.service.create(this.transferRequest).subscribe((response: ITransferRequest) => {
  //         if (response && response.isTransfer) {
  //           this.transferRequest = response;
  //           this.toastrService.success('transfer request added successful');
  //           this.router.navigate(['/employee/transfer-request/preference']);
  //         }
  //         else if (response && !response.isTransfer) {
  //           this.transferRequest = response;
  //           this.toastrService.success('transfer request added successful');
  //           this.router.navigate(['/employee/transfer-request/view']);
  //         }
  //       },
  //         (error) => console.log('HTTP Error', error),
  //         () => this.loading = false);
  //     }
  //   }
  // }
  save() {
    if (this.transferRequestForm.valid) {
      this.loading = true;
      this.transferRequest = Object.assign({}, this.transferRequestForm.value);
      if (this.id) {  
        this.service.update(this.id, this.transferRequest).subscribe((response: ITransferRequest) => {
          if (response && response.isTransfer) {
            this.transferRequest = response;
            this.toastrService.success('transfer request updated successful');
            this.router.navigate(['/employee/transfer-request/preference']);
          }
          else if (response && !response.isTransfer) {
            this.transferRequest = response;
            this.toastrService.success('transfer request updated successful');
            this.router.navigate(['/employee/transfer-request/view']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.transferRequest).subscribe((response: ITransferRequest) => {
          if (response && response.isTransfer) {
            this.transferRequest = response;
            this.toastrService.success('transfer request added successful');
            this.router.navigate(['/employee/transfer-request/preference']);
          }
          else if (response && !response.isTransfer) {
            this.transferRequest = response;
            this.toastrService.success('transfer request added successful');
            this.router.navigate(['/employee/transfer-request/view']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }


}
